import classNames from 'classnames';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';

import zidaneBlueSky from 'assets/userGroup/zidane-bluesky.jpg';

const Wrapper = styled(Vertical)`
  border-radius: var(--half-unit);
  overflow: hidden;
`;

const Img = styled.img`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 1;
`;

const Title = styled(Horizontal).attrs({ center: true })`
  background: var(--c-neutral-100);
  padding: var(--half-unit) 0;
`;

type Props = {
  withTitle?: boolean;
};
export const ZzReward = ({ withTitle }: Props) => {
  return (
    <Wrapper className={classNames({ withTitle })} gap={0}>
      {withTitle && (
        <Title>
          <LabelS bold>Zidane</LabelS>
        </Title>
      )}
      <Img src={zidaneBlueSky} alt="5v5 vs Zidane" />
    </Wrapper>
  );
};
